export default {"src":"https://images-cdn.curipod.com/d-81d97f49/_next/static/media/loaderstars.62e39e18.svg","height":669,"width":679};